import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    disabilities: [],
    disabilitiesCount: 0,
    disability: {},
    disabilitySave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getDisabilities(state) {
      return state.disabilities
    },
    getDisabilitiesCount(state) {
      return state.disabilitiesCount
    },
    getDisability(state) {
      return state.disability
    },
    getDisabilitySaveStatus(state) {
      return state.disabilitySave
    },
  },
  mutations: {
    DISABILITIES_LIST(state, data) {
      state.disabilities = data
    },
    DISABILITY_VIEW(state, data) {
      state.disability = data
    },
    DISABILITIES_COUNT(state, data) {
      state.disabilitiesCount = data
    },
    DISABILITY_SAVE(state, data) {
      state.disabilitySave = data
    },
  },
  actions: {
    disabilitiesList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hrDefines/disabilities', data)
        .then(response => {
          commit('DISABILITIES_LIST', response.data.data)
          commit('DISABILITIES_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    disabilityView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'disabilities.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hrDefines/disabilities', data)
        .then(response => {
          commit('DISABILITY_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    disabilitySave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hrDefines/disabilities/saveData', data)
        .then(response => {
          commit('DISABILITY_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
